<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='horizontal' :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model='queryParam.mobileNo'></a-input>
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t('customer.curp')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t('customer.curp'))"
                         v-model='queryParam.curp'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'loanStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.loanStatus'
                  :dict-code='DICT_CODE.LOAN_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'approvalStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.approvalStatus'
                  :dict-code='DICT_CODE.ORDER_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'settlementStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.settleStatus'
                  :dict-code='DICT_CODE.SETTLE_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                >
                </dict-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'applicationTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="12">
              <a-form-item :label="'主产品'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.mainSids'
                  allowClear
                >
                  <a-select-option v-for='item in mainAppList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12' >
              <a-form-item :label="'产品类型'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.appSsid'
                  allowClear
                >
                  <a-select-option v-for='item in appList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12' v-if="hasAdmin">
              <a-form-item
                :label="'风控盘'">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.riskAppSsid'
                  allowClear
                >
                  <a-select-option v-for='item in riskAppList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'custType')">
                <a-select default-value='' style='width: 100%' v-model='queryParam.custType'>
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    新户
                  </a-select-option>
                  <a-select-option value='2'>
                    老户
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'paymentTime')">
                <a-range-picker
                  v-model='queryParam.paymentTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'expireTime')">
                <a-range-picker
                  v-model='queryParam.endTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY + 'overdueStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.overdueStatus'
                  :dict-code='DICT_CODE.OVERDUE_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                >
                </dict-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="'订单类型'">
                <a-select default-value='' style='width: 100%' v-model='queryParam.orderType'>
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    展期订单
                  </a-select-option>
                  <a-select-option value='0'>
                    正常订单
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md='8' :sm='12'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
              <a-button v-if="roleCodes.includes('com_download') || roleCodes.includes('com')" type="primary" :disabled="!downloadAble" @click="downLoadData" icon="download" style="margin-left: 8px">导出</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination="false"
        :scroll="{ x: 'max-content' }"
        :loading='loading'
        bordered>
        <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
        <span v-if="isSearch" slot='action' slot-scope='text, record'>
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
        </span>
      </a-table>

      <!-- 前端本地分页控件 -->
      <div style='margin-top: 15px; text-align: right; display: flex; justify-content: flex-end; align-items: center; gap: 12px'>
        <span>每页展示：</span>
        <a-select v-model="form.pageSize" style="width: 80px" @change="sliceTableData">
          <a-select-option :value="10">10</a-select-option>
          <a-select-option :value="30">30</a-select-option>
          <a-select-option :value="50">50</a-select-option>
        </a-select>
        <v-pagination
          v-if='total > 0'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
    <v-modal
      v-model='visible'
      :title="$t(I18N_KEY + 'orderDetail')">
      <div style='padding: 20px;'>
        <order-detail v-if='visible' :orderId='orderId' :custInfoId='custInfoId' :mobileNo='mobileNo' :sysName='sysName' :isQuerySummary="true"/>
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getPlatformCrossAllOrderList, getRoleCode, getApplistExcludingSubApp } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import OrderDetail from '../order/CrossOrderDetail'
import moment from 'moment'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import exportFile from '@/api/exportFile'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = 'order.'
export default {
  name: 'AllOrderList',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail
  },
  data() {
    return {
      I18N_KEY,
      roleCodes:[],
      toggleSearchStatus: false,
      hasAdmin: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      mobileNo: undefined,
      downloadAble: true,
      isSearch: true,
      // 分页配置
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 存储接口返回全部数据（本地分页核心）
      allDataSource: [],
      // 表格当前展示切片数据
      dataSource: [],
      deadlineConfigList: [],
      queryParam: {
        'mainSids': '',
        'orderNo': '',
        'mobileNo': '',
        'aadhaarName': '',
        'createdTime': undefined,
        'paymentTime': undefined,
        'endTime': undefined,
        'overdueStatus': '',
        'loanStatus': '',
        'approvalStatus': '',
        'settleStatus': '',
        'appSsid': '',
        'custType': '',
        'riskAppSsid': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      appList: [],
      riskAppList: [],
      mainAppList: [],
      mainInAppList: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'productName'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t(I18N_KEY + 'custType'),
          align: 'left',
          dataIndex: 'loanCount',
          customRender: (text, row) => {
            return text > 1 ? '老户' : '新户'
          }
        },
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t('customer.names'),
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: this.$t('customer.surnames'),
          align: 'left',
          dataIndex: 'surnames'
        },
        {
          title: this.$t('customer.curp'),
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t(I18N_KEY + 'loanAmount'),
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'paymentTime'),
          align: 'left',
          dataIndex: 'paymentTime'
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementTime'),
          align: 'left',
          dataIndex: 'settleTime'
        },
        {
          title: this.$t(I18N_KEY + 'overdueStatus'),
          align: 'left',
          dataIndex: 'overdueStatus',
          scopedSlots: { customRender: 'overdueStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t(I18N_KEY + 'expireTime'),
          align: 'left',
          dataIndex: 'endDate'
        },
        // {
        //   title: this.$t(I18N_KEY + 'sysName'),
        //   align: 'left',
        //   dataIndex: 'sysName'
        // },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.getIsShowRiskBtn();
    getRoleCode().then(res => {
      this.roleCodes = res.data || []
    })
    getApplist().then(res => {
      this.appList = res.data || []
    })
    getApplist({ riskType: 'risk' }).then(res => {
      this.riskAppList = res.data || [];
    })
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
    getApplistExcludingSubApp().then(res => {
      this.mainAppList = []
      this.mainInAppList = res.data || []
      for (var i = 0; i < this.mainInAppList.length; i++) {
        if (this.mainInAppList[i].appssid != '') {
          this.mainAppList.push(this.mainInAppList[i])
        }
      }
    });
    // 页面初始化不自动加载，需要手动点查询
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    // 查询按钮：拉取全部数据
    searchQuery() {
      this.form.pageNum = 1
      this.loadAllData()
    },
    getIsShowRiskBtn() {
      const roleCodeStr = localStorage.getItem('roleCodes');
      try {
        const roleCodeArray = JSON.parse(roleCodeStr);
        if (Array.isArray(roleCodeArray)) {
          this.hasAdmin = roleCodeArray.includes('SUPER_ADMIN') || roleCodeArray.includes('admin');
        }
      } catch (e) {
        this.hasAdmin = false;
      }
    },
    // 请求接口获取全部数据，无分页参数传给后端
    loadAllData() {
      this.loading = true
      const params = this.getQueryParams()
      getPlatformCrossAllOrderList(params).then((res) => {
        if (res.code === 1000) {
          // 保存全部数据
          this.allDataSource = res.data.rows || []
          // 总条数 = 全部数据长度
          this.total = this.allDataSource.length
          // 前端切片当前页数据
          this.sliceTableData()

          if (this.queryParam.riskAppSsid?.trim() === '') {
            this.isSearch = true;
          } else {
            this.isSearch = false;
          }
        } else {
          this.total = 0
          this.allDataSource = []
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    // 前端本地切片逻辑（核心）
    sliceTableData() {
      const { pageNum, pageSize } = this.form
      // 计算截取起始下标
      const start = (pageNum - 1) * pageSize
      const end = pageNum * pageSize
      // 截取当前页数据赋值给表格
      this.dataSource = this.allDataSource.slice(start, end)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    // 去掉pageNum/pageSize，只传查询条件给后端
    getQueryParams() {
      const userId = localStorage.getItem('userId');
      const { createdTime, paymentTime, endTime } = this.queryParam
      const data = {
        ...this.queryParam,
        applyDateStart: (createdTime && createdTime.length) ? this.transformTime(createdTime[0]) : undefined,
        applyDateEnd: (createdTime && createdTime.length) ? this.transformTime(createdTime[1]) : undefined,
        paymentTimeStart: (paymentTime && paymentTime.length) ? this.transformTime(paymentTime[0]) : undefined,
        paymentTimeEnd: (paymentTime && paymentTime.length) ? this.transformTime(paymentTime[1]) : undefined,
        endDateStart: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined,
        loginUserId: userId,
        useUser: "1"
      }
      delete data.createdTime
      delete data.paymentTime
      delete data.endTime
      // 过滤空参数
      return filterObj(data)
    },
    // 切换页码（仅前端切片，不请求接口）
    handleTableChange(pageNum) {
      this.form.pageNum = pageNum
      this.sliceTableData()
    },
    // 重置搜索
    searchReset() {
      this.queryParam = {
        mainSids: '',
        orderNo: '',
        mobileNo: '',
        aadhaarName: '',
        createdTime: undefined,
        paymentTime: undefined,
        endTime: undefined,
        overdueStatus: '',
        loanStatus: '',
        approvalStatus: '',
        settleStatus: '',
        appSsid: '',
        custType: '',
        riskAppSsid: '',
        curp: '',
        orderType: ''
      }
      // 清空全量数据、表格数据
      this.allDataSource = []
      this.dataSource = []
      this.total = 0
      this.form.pageNum = 1
    },
    async downLoadData () {
      this.$confirm({
        title: '确认导出',
        content: "最多导出10000条数据，请控制时间范围，是否确认导出？",
        onOk: async () => {
          this.downloadAble = false;
          const p = this.getQueryParams()
          delete p.pageNum; delete p.pageSize
          this.loading = true
          try { await exportFileByPost('/api/web/webpublic/platform/order/exportCrossOrderExcel', p, 'order.xlsx') }
          catch (e) { this.$message.error(e.message) }
          finally { this.loading = false;this.downloadAble = true; }
        },
        onCancel: () => {
           this.$message.info('已取消')
        }
      })
    },
    // async downLoadCrossData() {
    //   const p = this.getQueryParams()
    //   delete p.pageNum; delete p.pageSize
    //   this.loading = true
    //   try { await exportFileByPost('/api/web/webpublic/platform/order/exportCrossOrderExcel', p, 'order.xlsx') }
    //   catch (e) { this.$message.error(e.message) }
    //   finally { this.loading = false;this.downloadAble = true; }
    // },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.mobileNo = row.mobileNo
      this.sysName = row.sysName
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>